import React, { useEffect, useState } from "react";
import { get } from "lodash";

import Modal from "~/shared/ui/Fields/Modal";
import { getFormatDate } from "~/libs/getFormatDate";
import { Profile, useGetProfileQuery } from "~/schemas/generated/graphql";

import s from "./EmailAlert.less";

const EmailAlert = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { data } = useGetProfileQuery();
  const user: Profile = get(data, "UserGetter.getProfile");

  const closeModal = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    if (user && user.lockDate) {
      setIsOpen(true);
    }
  }, [user]);

  if (!user) {
    return null;
  }

  const { fullname, email, lockDate } = user;

  const blockDate = new Date(lockDate);
  blockDate.setDate(blockDate.getDate() + 10);

  return (
    <Modal isOpen={isOpen} actionClose={closeModal}>
      <div>
        <p>
          {" "}
          Уважаемый пользователь, <span className={s.title}>{fullname}</span>
        </p>
        <p>
          {" "}
          В вашем e-mail : <span className={s.title}>{email}</span> содержится
          доменное имя не соответствующее допустимому набору доменных имен ДЦ
        </p>
        <p>
          {" "}
          Произведите редактирование email, иначе вам будет закрыт доступ в
          систему Паспорт Дилера
        </p>
        <p>
          Учетная запись будет заблокирована{" "}
          <span className={s.title}>{getFormatDate(blockDate, true)}</span>
        </p>
      </div>
    </Modal>
  );
};

export default EmailAlert;
